<script lang="ts" setup>
import { useField } from 'vee-validate'
import type { FieldUIProp, RadioOption, UIProp } from '~/types/elementsUi'

interface FormRadioProps {
  name: string
  label: string
  options: RadioOption[]
  disabled?: boolean
  grid?: boolean

  ui?: FieldUIProp & UIProp<'radio'>
}

const props = defineProps<FormRadioProps>()

const { value, handleBlur, errors } = useField<
  string | boolean | number | null | RadioOption
>(props.name)

const $form = useInjectedId(props.name)

const color = computed(() => {
  if (errors.value.length > 0) {
    return 'danger'
  } else if (value.value) {
    return 'success'
  }
  return undefined
})

const computedUi = computed(() =>
  nuxtUiMerge(props.ui, {
    control: props.grid ? tw`has-grid` : ''
  })
)
</script>

<template>
  <VField
    type="fieldset"
    :color
    :label
    :name
    :message="errors.join('\n')"
    class="radio-form"
    :ui="computedUi"
  >
    <template v-if="$slots['label']" #label>
      <slot name="label" />
    </template>
    <slot name="content" />
    <VRadio
      v-for="(option, index) in options"
      :key="`${name}-radio-option-${index}`"
      v-model="value"
      :class="computedUi?.radio"
      :disabled
      :name
      :value="option.id"
      @blur="handleBlur"
    >
      {{ option.name }}
    </VRadio>
  </VField>
</template>

<style scoped></style>
